import {autorun, toJS} from "mobx";
import {v4 as uuid} from "uuid";
import {connection} from "./connection";
import {cubeModel} from "./cube";
import {occupancyModel} from "./occupancy";
import {TraceEvent} from "./types";

const FlushInterval = 5000;
const SessionId = uuid();

const TraceEnabled = false;

class TraceModel {
	constructor() {
		if (TraceEnabled) {
			const periodicFlush = async () => {
				await this.flush();
				setTimeout(periodicFlush, FlushInterval);
			};
			setTimeout(periodicFlush, FlushInterval);
		}
	}

	private buffer: TraceEvent[] = [];
	private flushing = false;

	add(subject: string, data: {}) {
		if (TraceEnabled) {
			this.buffer.push({
				timestamp: new Date().toISOString(),
				subject: subject,
				data: JSON.stringify({
					sessionId: SessionId,
					...data,
				}),
			});
		}
	}

	async flush() {
		if (!this.flushing && this.buffer.length > 0) {
			this.flushing = true;
			try {
				await connection.trace(this.buffer);
				this.buffer = [];
			}
			catch (error) {
				console.error("Error while sending trace events to server", error);
			}
			finally {
				this.flushing = false;
			}
		}
	}
}

export const trace = new TraceModel();

if (TraceEnabled) {
	autorun(() =>
		trace.add("application state", {
			cubes: toJS(cubeModel.cubes),
			occupancies: toJS(occupancyModel.occupancies),
		})
	);
}
